<template>
  <el-dialog title="工作记录选择"
             :modal="false"
             :visible.sync="dialogVisible"
             @closed="onClear"
             width="50%">
    <el-row>
      <el-popover v-model="popoverVisible"
                  placement="bottom-start"
                  width="100%"
                  trigger="focus">
        <el-input v-model="searchTxt"
                  size="small"
                  slot="reference"
                  @keyup.enter.native.enter="searchFullText "
                  placeholder="输入文字全文检索">
          <el-button type='warning'
                     size="small"
                     style="margin-left:10px"
                     @click="showSearch">精确搜索</el-button>
        </el-input>
        <div class="tip-div">
          <el-tag v-for="(item,index) in searchTips"
                  effect="plain"
                  :type="item.type"
                  :key="index"
                  style="cursor:pointer;margin-left: 5px;margin-top: 15px;"
                  @click.native="searchByTips(item.value)">{{item.name}}</el-tag>
        </div>
      </el-popover>
      <el-button slot="append"
                 @click="searchFullText "
                 icon="el-icon-search"></el-button>
    </el-row>
    <TaskRecordGrid :source="dataSource"
                    style="margin-top:10px"
                    ref="taskRecordGrid"
                    :multiSelected="true"></TaskRecordGrid>
    <div class="el-row">
      <el-pagination @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     @prev-click="handleCurrentChange"
                     @next-click="handleCurrentChange"
                     :current-page.sync="pageIndex"
                     :page-size="pageSize"
                     :page-sizes="[10, 30, 50, 100]"
                     layout="total, sizes,prev, pager, next, jumper"
                     :total="totalCount">
      </el-pagination>
    </div>
    <TaskRecordSearch ref="recordSearch"
                      @searchRecord="searchRecord"></TaskRecordSearch>
    <span slot="footer"
          class="dialog-footer">
      <el-button type="primary"
                 @click="onSuccess">确 定</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>

    </span>
  </el-dialog>
</template>
//工作记录检索
<script>
import {
  GetAllRecordByParam,
  GetRecordLuneceQuery
} from "@/api/modules/basicData/task";
import TaskRecordGrid from "./TaskRecordGrid.vue";
import TaskRecordSearch from "./TaskRecordSearch.vue";
import { getToken } from "@/util/auth";
import timeJs from "@/util/timeFormat";
const cookieUser = getToken();
export default {
  components: {
    TaskRecordGrid,
    TaskRecordSearch
  },
  data() {
    return {
      dialogVisible: false,
      recordPara: {},
      pageIndex: 1,
      totalCount: 0,
      pageSize: 10,
      searchTxt: "",
      dataSource: [],
      popoverVisible: false,
      isLuceneSearch: false,
      searchTips: [
        { name: "我创建的", value: "0", type: "" },
        { name: "我关注的", value: "1", type: "success" },
        { name: "最近一天", value: "2", type: "info" },
        { name: "最近一周", value: "3", type: "warning" },
        { name: "最近一个月", value: "4", type: "danger" }
      ]
    };
  },
  methods: {
    searchFullText() {
      this.pageIndex = 1;
      this.isLuceneSearch = true;
      GetRecordLuneceQuery(this.pageIndex, this.pageSize, this.searchTxt, {
        CurrentUserId: cookieUser.userId
      }).then(result => {
        if (result) {
          console.log(result);
          this.totalCount = result.TotalItems;
          this.dataSource = result.Items;
        }
      });
      this.popoverVisible = false;
    },
    onClear() {
      this.$refs.taskRecordGrid.clearSelection();
      this.popoverVisible = false;
      this.searchTxt = "";
    },
    onSuccess() {
      let rows = this.$refs.taskRecordGrid.getValue();
      this.$emit("getValue", rows);
      this.dialogVisible = false;
    },
    createclickitem(e) {
      e === this.createtimeRadio
        ? (this.createtimeRadio = "")
        : (this.createtimeRadio = e);
    },
    searchByTips(val) {
      this.isLuceneSearch = false;
      this.recordPara = {
        CurUserId: cookieUser.userId,
        RecordType: -1,
        SelectIndex: -1
      };
      switch (val) {
        case "0":
          this.recordPara.SelectIndex = 0; //我创建的
          break;
        case "1":
          this.recordPara.SelectIndex = 2; //我关注的
          break;
        case "2": //最近一周的
          this.recordPara.CreateTime1 = timeJs.getToday(-1);
          this.recordPara.CreateTime2 = timeJs.getToday(0);
          break;
        case "3": //最近一周的
          this.recordPara.CreateTime1 = timeJs.getToday(-7);
          this.recordPara.CreateTime2 = timeJs.getToday(0);
          break;
        case "4": //最近一个月的
          this.recordPara.CreateTime1 = timeJs.getToday(-30);
          this.recordPara.CreateTime2 = timeJs.getToday(0);
          break;
      }

      GetAllRecordByParam(this.pageIndex, this.pageSize, this.recordPara).then(
        result => {
          if (result) {
            console.log(result);
            this.totalCount = result.TotalItems;
            this.dataSource = result.Items;
            this.popoverVisible = false;
          }
        }
      );
    },
    showSearch() {
      this.$refs.recordSearch.dialogVisible = true;
    },
    //搜索工作记录
    searchRecord(recordPara) {
      this.para = recordPara;
      GetAllRecordByParam(this.pageIndex, this.pageSize, recordPara).then(
        result => {
          if (result) {
            console.log(result);
            this.totalCount = result.TotalItems;
            this.dataSource = result.Items;
          }
        }
      );
    },
    handleSizeChange(val) {
      this.pageSize = val;
      if (this.isLuceneSearch) {
        this.searchFullText();
      } else {
        this.searchRecord(this.para);
      }
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      if (this.isLuceneSearch) {
        this.searchFullText();
      } else {
        this.searchRecord(this.para);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.tip-div {
  flex-wrap: wrap;
  display: flex;
  align-items: center;
  width: 100%;
}
</style>